import React from 'react'
import BannerTwo from '../Components/Banner/BannerTwo'
import HeaderOne from '../Components/Header/HeaderOne'
import DestinationTwo from '../Components/Destination/DestinationTwo'
import CategoryTwo from '../Components/Category/CategoryTwo'
import OfferOne from '../Components/Offer/OfferOne'
import PopularDestination from '../Components/Destination/PopularDestination'
import CounterTwo from '../Components/Counter/CounterTwo'
import GalleryTwo from '../Components/Gallery/GalleryTwo'
import TestimonialTwo from '../Components/Testimonials/TestimonialTwo'
import BrandOne from '../Components/Brand/BrandOne'
import BlogTwo from '../Components/Blog/BlogTwo'
import FooterFour from '../Components/Footer/FooterFour'
import ElementSection from '../Components/Elements/ElementSection'
import ScrollToTop from '../Components/ScrollToTop'

function HomeTwo() {
  return (
    <div>
      <HeaderOne />
      <BannerTwo />
      <DestinationTwo />
      <CategoryTwo />
      <OfferOne />
      <PopularDestination />
      <CounterTwo />
      <GalleryTwo />
      <TestimonialTwo />
      <BrandOne className="space-bottom"/>
      <BlogTwo />
      <ElementSection className="bg-smoke"/>
      <FooterFour />
      <ScrollToTop />
    </div>
  )
}

export default HomeTwo
